import { patchUser } from 'api/User/actions'
import { FETCH_USER_SUCCESS } from 'api/User/constants'
import { userLanguage } from 'api/User/selectors'
import { localeInstance } from 'locale'
import { setLanguage } from 'redux-i18n'
import { createLogic } from 'redux-logic'
import type { ReduxLogicState } from 'types/logic'

import { selectLanguage } from './selectors'

interface LanguageLogicProcess extends ReduxLogicState {
  action: {
    payload: {
      language: string
    }
  }
}

const languageLogic = createLogic({
  type: FETCH_USER_SUCCESS,
  latest: true,

  async process({ action, getState }: LanguageLogicProcess, dispatch, done) {
    try {
      const language = action.payload.language.toLowerCase()
      const currentLang = selectLanguage(getState())

      if (currentLang !== language) {
        dispatch(setLanguage(language))
      }

      await localeInstance.changeLanguage(language)
      localStorage.setItem('i18nextLng', language)
    } catch (error) {
      // Not interested
    }
    done()
  },
})

interface UpdateUserLanguageProcess extends ReduxLogicState {
  action: {
    lang: string
  }
}

const updateUserLanguage = createLogic({
  type: 'REDUX_I18N_SET_LANGUAGE',
  latest: true,

  async process({ action, getState }: UpdateUserLanguageProcess, dispatch, done) {
    try {
      const language = userLanguage(getState())
      const i18nLanguage = action?.lang

      if (i18nLanguage && language?.toLowerCase() !== i18nLanguage.toLowerCase()) {
        dispatch(
          patchUser({
            language: i18nLanguage.toUpperCase(),
          }),
        )
      }
    } catch (error) {
      // Not interested
    }

    done()
  },
})

export default [languageLogic, updateUserLanguage]
